import { FC } from "react";

import { Icon, IconName, IconSize } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

import "./AccumulatorProgressBar.scss";
import { MoneyAccumulationValues } from "@/App/types/accumulation";
import { formatDollars } from "@/App/utils/utils";
import { isMedicalCareUsageAccumulationValues, MedicalCareUsageAccumulationValues } from "@/App/types/medicalServiceMaximums";

export interface AccumulatorProgressBarProps {
  readonly accumulator: MoneyAccumulationValues | MedicalCareUsageAccumulationValues;
  readonly spentHelpText: string;
  readonly remainingHelpText: string;
  readonly limitReached?: boolean;
  readonly limitReachedWarning?: boolean;
  readonly iconName?: IconName;
  readonly iconSize?: IconSize;
}

export const AccumulatorProgressBar: FC<AccumulatorProgressBarProps> = ({ accumulator, spentHelpText, remainingHelpText, limitReached, iconName = "check-mark", iconSize = "regular", limitReachedWarning = false }) => {
  const { spent, max, remaining } = accumulator;
  const isMoneyAccumulator = !isMedicalCareUsageAccumulationValues(accumulator);
  const formattedSpent = isMoneyAccumulator ? formatDollars(spent.toString()) : spent.toString();
  const formattedRemaining = isMoneyAccumulator ? formatDollars(remaining.toString()) : remaining.toString();

  return (
    <div className="accumulatorProgressBarContainer">
      <div className="accumulatorProgressBar">
        <div className="accumulatorProgressBarFill" style={{ width: `calc(${spent.toNumber() / max.toNumber() * 100}%)` }}></div>
        {limitReached && (
          <div className="accumulatorProgressBulb accumulatorProgressBulbComplete">
            <Icon name={iconName} color={"white"} size={iconSize}/>
          </div>
        )}
        {!limitReached && <div className="accumulatorProgressBulb"></div>}
      </div>
      <Stack spacing="none">
        <Shelf>
          <Body textAlign="left"><Semibold>{formattedSpent}</Semibold></Body>
          <Shelf.Spacer />
          <Body textAlign="right"><Semibold className={(limitReached && limitReachedWarning) ? "accumulatorRemaining--limitReached" : ""}>{formattedRemaining}</Semibold></Body>
        </Shelf>
        <Shelf>
          <Body textAlign="left">{spentHelpText}</Body>
          <Shelf.Spacer />
          <Body textAlign="right">{remainingHelpText}</Body>
        </Shelf>
      </Stack>
    </div>
  );
};
